export default __webpack_public_path__ + "static/media/bellAlertTrans.5df250c3.svg";